const fallbackApiUrl = typeof window !== 'undefined'
  ? `${window.location.origin}/api`
  : 'http://localhost:3000/api';

const configuredApiUrl = process.env.VUE_APP_API_URL;
const isBrowser = typeof window !== 'undefined';
const isLocalPage = isBrowser && /^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname);
const configuredApiUrlIsLocal = configuredApiUrl && /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?\/api\/?$/i.test(configuredApiUrl);

export default {
  launch: configuredApiUrl && (!configuredApiUrlIsLocal || !isBrowser || isLocalPage)
    ? configuredApiUrl
    : fallbackApiUrl
}

